(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apercuebook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-ebook-preview')) {
    customElements.define('cl-ebook-preview', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.dialog = this.querySelector('[data-dialog]');
        this.activeIndex = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));

        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-tab]');
          if (tab && this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab));
          const zoom = event.target.closest('[data-open-zoom]');
          if (zoom && this.contains(zoom) && this.dialog && typeof this.dialog.showModal === 'function') {
            event.preventDefault();
            this.openZoom(zoom);
          }
          if (event.target.closest('[data-close]')) this.dialog?.close();
          if (event.target.closest('[data-magnify]')) this.setMagnified(this.dialog.dataset.magnified !== 'true');
        }, options);

        this.addEventListener('keydown', event => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(next, true);
        }, options);

        document.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
          if (index !== -1) {
            if (this.dialog?.open) this.dialog.close();
            this.select(index);
          }
        }, options);

        if (this.dialog) {
          this.dialog.addEventListener('close', () => {
            this.restoreScroll();
            if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
          }, options);
          this.dialog.addEventListener('click', event => {
            if (event.target !== this.dialog) return;
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }, options);
        }
      }

      select(index, focus = false) {
        if (!this.tabs[index]) return;
        this.activeIndex = index;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        const activeImage = this.panels[index]?.querySelector('img');
        if (activeImage) activeImage.loading = 'eager';
        if (focus) this.tabs[index].focus();
      }

      openZoom(link) {
        if (this.dialog.open) return;
        this.returnFocus = link;
        const image = this.dialog.querySelector('[data-dialog-image]');
        image.src = link.href;
        image.alt = link.dataset.alt || '';
        this.dialog.querySelector('[data-dialog-title]').textContent = link.dataset.caption || '';
        this.setMagnified(false);
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.dialog.querySelector('[data-close]').focus({ preventScroll: true });
      }

      setMagnified(active) {
        if (!this.dialog) return;
        this.dialog.dataset.magnified = String(active);
        const toggle = this.dialog.querySelector('[data-magnify]');
        toggle.setAttribute('aria-pressed', String(active));
        toggle.textContent = active ? this.dataset.zoomOutLabel : this.dataset.zoomInLabel;
        const scroller = this.dialog.querySelector('[data-dialog-scroll]');
        scroller.scrollTop = 0;
        scroller.scrollLeft = 0;
      }

      restoreScroll() {
        if (!this.scrollLocked) return;
        document.body.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avisgoogle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loeffel-google-reviews')) {
    customElements.define('loeffel-google-reviews', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.viewport = this.querySelector('[data-review-list]');
        if (!this.viewport) return;
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.navigation = this.querySelector('[data-navigation]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.setAttribute('data-enhanced', '');

        this.previous?.addEventListener('click', () => this.step(-1), options);
        this.next?.addEventListener('click', () => this.step(1), options);
        this.viewport.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.maximum());
          }
        }, options);

        this.querySelectorAll('[data-expand]').forEach((button) => {
          button.addEventListener('click', () => {
            const body = button.closest('[data-review-card]').querySelector('[data-review-text]');
            const expanded = button.getAttribute('aria-expanded') !== 'true';
            body.toggleAttribute('data-expanded', expanded);
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
          }, options);
        });

        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:block:select', (event) => {
            const card = this.cards.find((item) => item.dataset.blockId === event.detail?.blockId);
            if (card) this.goTo(this.position(card), true);
          }, options);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.refresh(), options);
        }
        if (document.fonts) {
          document.fonts.addEventListener('loadingdone', () => this.refresh(), options);
          document.fonts.ready.then(() => {
            if (!options.signal.aborted) this.refresh();
          });
        }
        this.refresh();
      }

      maximum() {
        return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      }

      position(card) {
        return Math.max(0, this.viewport.scrollLeft + card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left);
      }

      goTo(position, immediate = false) {
        this.viewport.scrollTo({
          left: Math.max(0, Math.min(this.maximum(), position)),
          behavior: immediate || this.motion.matches ? 'auto' : 'smooth'
        });
      }

      step(direction) {
        const current = this.viewport.scrollLeft;
        const positions = this.cards.map((card) => Math.min(this.maximum(), this.position(card)));
        const target = direction > 0
          ? positions.find((position) => position > current + 3)
          : positions.slice().reverse().find((position) => position < current - 3);
        this.goTo(target ?? (direction > 0 ? this.maximum() : 0));
      }

      updateNavigation() {
        const max = this.maximum();
        if (this.navigation) this.navigation.hidden = max < 3;
        if (this.previous) this.previous.disabled = this.viewport.scrollLeft < 3;
        if (this.next) this.next.disabled = this.viewport.scrollLeft > max - 3;
      }

      refresh() {
        this.updateNavigation();
        this.querySelectorAll('[data-review-text]').forEach((body) => {
          const button = body.parentElement.querySelector('[data-expand]');
          if (!button) return;
          if (body.hasAttribute('data-expanded')) {
            button.hidden = false;
          } else {
            button.hidden = body.scrollHeight <= body.clientHeight + 2;
          }
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqqq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-editorial-faq')) {
    customElements.define('cl-editorial-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('toggle', event => {
          const current = event.target;
          if (this.dataset.single !== 'true' || !current.matches('[data-faq-item]') || !current.open) return;
          this.querySelectorAll('[data-faq-item]').forEach(item => {
            if (item !== current) item.open = false;
          });
        }, { capture: true, signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = Array.from(this.querySelectorAll('[data-faq-item]')).find(item => item.dataset.blockId === event.detail?.blockId);
          if (selected) selected.open = true;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galerieavis"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('loeffel-review-gallery')) return;
  class LoeffelReviewGallery extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.viewport = this.querySelector('[data-lrg-viewport]');
      this.track = this.querySelector('[data-lrg-track]');
      this.original = this.querySelector('[data-lrg-original]');
      if (!this.viewport || !this.track || !this.original) return;
      this.cards = Array.from(this.original.querySelectorAll('[data-lrg-card]'));
      this.controls = this.querySelector('[data-lrg-controls]');
      this.footer = this.querySelector('[data-lrg-footer]');
      this.previousButton = this.querySelector('[data-lrg-prev]');
      this.nextButton = this.querySelector('[data-lrg-next]');
      this.dialog = this.querySelector('[data-lrg-dialog]');
      this.controller = new AbortController();
      this.mobile = matchMedia('(max-width: 749px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.position = 0;
      this.expectedScroll = 0;
      this.cycle = 0;
      this.loop = false;
      this.hovered = false;
      this.focused = false;
      this.pointerDown = false;
      this.interacting = false;
      this.editorSelected = false;
      this.inView = true;
      this.raf = 0;
      this.lastTime = 0;
      const signal = this.controller.signal;
      const on = (element, name, callback, options = {}) => {
        if (element) element.addEventListener(name, callback, { ...options, signal });
      };
      on(this.previousButton, 'click', () => this.step(-1));
      on(this.nextButton, 'click', () => this.step(1));
      on(this.viewport, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.pauseHover === 'true') {
          this.hovered = true;
          this.update();
        }
      });
      on(this.viewport, 'pointerleave', () => { this.hovered = false; this.update(); });
      on(this.viewport, 'pointerdown', () => { this.pointerDown = true; this.update(); }, { passive: true });
      const releasePointer = () => {
        if (!this.pointerDown) return;
        this.pointerDown = false;
        this.position = this.viewport.scrollLeft;
        this.pauseForInteraction();
      };
      on(window, 'pointerup', releasePointer, { passive: true });
      on(window, 'pointercancel', releasePointer, { passive: true });
      on(this.viewport, 'wheel', () => this.pauseForInteraction(), { passive: true });
      on(this.viewport, 'scroll', () => {
        const current = this.viewport.scrollLeft;
        if (Math.abs(current - this.expectedScroll) < 1.5) return;
        this.position = current;
        this.expectedScroll = current;
        if (!this.pointerDown) this.pauseForInteraction();
        this.updateNavigation();
      }, { passive: true });
      on(this.viewport, 'focusin', event => {
        this.focused = true;
        const card = event.target.closest('[data-lrg-card]');
        if (card) this.seekCard(card.dataset.lrgCard);
        this.update();
      });
      on(this.viewport, 'focusout', () => {
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => {
          this.focused = this.viewport.contains(document.activeElement);
          this.update();
        }, 0);
      });
      on(document, 'visibilitychange', () => this.update());
      on(this.mobile, 'change', () => this.rebuild());
      on(this.reducedMotion, 'change', () => this.rebuild());
      on(this.viewport, 'click', event => this.openPhoto(event));
      on(this.querySelector('[data-lrg-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      on(this.dialog, 'close', () => this.closePhoto());
      on(document, 'shopify:block:select', event => {
        const id = event.detail && event.detail.blockId;
        if (!this.cards.some(card => card.dataset.lrgCard === id)) return;
        this.editorSelected = true;
        this.rebuild();
        this.seekCard(id);
      });
      on(document, 'shopify:block:deselect', event => {
        if (!event.detail || !this.cards.some(card => card.dataset.lrgCard === event.detail.blockId)) return;
        this.editorSelected = false;
        this.rebuild();
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            const width = this.viewport.clientWidth;
            const cycle = this.original.getBoundingClientRect().width;
            if (width !== this.lastWidth || Math.abs(cycle - this.cycle) > .5) this.rebuild();
          });
        });
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.original);
      } else {
        on(window, 'resize', () => this.rebuild(), { passive: true });
      }
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.update();
        }, { rootMargin: '100px' });
        this.intersectionObserver.observe(this);
      }
      this.rebuild();
    }
    canAnimate() {
      return this.cards.length > 1 && this.dataset.autoplay === 'true' &&
        (!this.mobile.matches || this.dataset.autoplayMobile === 'true') &&
        !this.reducedMotion.matches && !this.editorSelected;
    }
    rebuild() {
      this.stop();
      this.track.querySelectorAll('[data-lrg-clone]').forEach(clone => clone.remove());
      this.cycle = this.original.getBoundingClientRect().width;
      this.lastWidth = this.viewport.clientWidth;
      this.loop = this.canAnimate() && this.cycle > 0 && this.lastWidth > 0;
      if (this.loop) {
        const count = Math.ceil(this.lastWidth / this.cycle) + 1;
        for (let i = 0; i < count; i++) {
          const clone = this.original.cloneNode(true);
          clone.removeAttribute('data-lrg-original');
          clone.setAttribute('data-lrg-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
            node.removeAttribute('data-shopify-editor-section');
          });
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
          this.track.append(clone);
        }
      }
      this.writePosition(this.position);
      this.update();
    }
    writePosition(value) {
      let next = value;
      if (this.loop && this.cycle > 0) next = ((value % this.cycle) + this.cycle) % this.cycle;
      else next = Math.max(0, Math.min(value, this.viewport.scrollWidth - this.viewport.clientWidth));
      this.position = next;
      this.expectedScroll = next;
      this.viewport.scrollLeft = next;
    }
    update() {
      if (!this.controller) return;
      const motionAvailable = this.loop;
      const canScroll = this.loop || this.viewport.scrollWidth > this.viewport.clientWidth + 1;
      if (this.controls) this.controls.hidden = !(canScroll && this.previousButton);
      if (this.footer) this.footer.hidden = (!this.controls || this.controls.hidden) && !this.footer.querySelector('.lrg__button');
      if (this.previousButton) this.previousButton.hidden = !canScroll;
      if (this.nextButton) this.nextButton.hidden = !canScroll;
      this.updateNavigation();
      const running = motionAvailable && !this.hovered && !this.focused && !this.pointerDown && !this.interacting &&
        !this.editorSelected && !document.hidden && this.inView && !(this.dialog && this.dialog.open);
      if (running && !this.raf) {
        this.lastTime = 0;
        this.raf = requestAnimationFrame(time => this.tick(time));
      } else if (!running) this.stop();
    }
    tick(time) {
      this.raf = 0;
      if (!this.isConnected || !this.controller) return;
      const elapsed = this.lastTime ? Math.min((time - this.lastTime) / 1000, .05) : 0;
      this.lastTime = time;
      const configured = this.mobile.matches ? this.dataset.speedMobile : this.dataset.speed;
      const speed = Math.max(1, Number(configured) || 30);
      const direction = this.dataset.direction === 'right' ? -1 : 1;
      this.writePosition(this.position + elapsed * speed * direction);
      this.raf = requestAnimationFrame(next => this.tick(next));
    }
    stop() {
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.lastTime = 0;
    }
    pauseForInteraction() {
      this.interacting = true;
      clearTimeout(this.interactionTimer);
      this.update();
      this.interactionTimer = setTimeout(() => {
        this.interacting = false;
        this.position = this.viewport.scrollLeft;
        this.update();
      }, 1800);
    }
    step(direction) {
      if (!this.cards.length) return;
      this.pauseForInteraction();
      const first = this.cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.original).columnGap) || 0;
      this.writePosition(this.viewport.scrollLeft + direction * (first + gap));
      this.update();
    }
    updateNavigation() {
      if (!this.previousButton || !this.nextButton) return;
      this.previousButton.disabled = !this.loop && this.viewport.scrollLeft < 1;
      this.nextButton.disabled = !this.loop && this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 1;
    }
    seekCard(id) {
      const card = this.cards.find(item => item.dataset.lrgCard === id);
      if (card) this.writePosition(card.offsetLeft);
    }
    openPhoto(event) {
      const link = event.target.closest('[data-lrg-photo]');
      if (!link || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const shownCard = link.closest('[data-lrg-card]');
      const card = this.cards.find(item => item.dataset.lrgCard === shownCard.dataset.lrgCard);
      if (!card) return;
      event.preventDefault();
      this.returnFocus = card.querySelector('[data-lrg-photo]');
      const photo = this.querySelector('[data-lrg-dialog-image]');
      photo.src = this.mobile.matches ? (link.dataset.lrgMobileSrc || link.href) : link.href;
      photo.alt = card.querySelector('img')?.alt || 'Photo d’un cours privé de pâtisserie';
      const details = this.querySelector('[data-lrg-dialog-details]');
      details.replaceChildren();
      const template = card.querySelector('[data-lrg-details]');
      if (template) details.append(template.content.cloneNode(true));
      this.oldBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.update();
    }
    closePhoto() {
      if (this.oldBodyOverflow !== undefined) {
        document.body.style.overflow = this.oldBodyOverflow;
        this.oldBodyOverflow = undefined;
      }
      if (this.isConnected && this.returnFocus) this.returnFocus.focus({ preventScroll: true });
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.stop();
      clearTimeout(this.interactionTimer);
      clearTimeout(this.focusTimer);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.controller) this.controller.abort();
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.oldBodyOverflow !== undefined) document.body.style.overflow = this.oldBodyOverflow;
      this.oldBodyOverflow = undefined;
      this.controller = null;
    }
  }
  customElements.define('loeffel-review-gallery', LoeffelReviewGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recettecourscadeau"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loeffel-offers-slider')) {
    customElements.define('loeffel-offers-slider', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.dataset.mobileSlider !== 'true') return;
        this.track = this.querySelector('[data-lu-track]');
        this.cards = Array.from(this.querySelectorAll('[data-lu-slide]'));
        if (!this.track || !this.cards.length) return;
        this.controls = this.querySelector('[data-lu-controls]');
        this.previous = this.querySelector('[data-lu-previous]');
        this.next = this.querySelector('[data-lu-next]');
        this.dots = Array.from(this.querySelectorAll('[data-lu-dot]'));
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.setAttribute('data-enhanced', '');

        this.previous?.addEventListener('click', () => this.step(-1), options);
        this.next?.addEventListener('click', () => this.step(1), options);
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.luDot)), options);
        });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
          }
        }, options);
        this.mobile.addEventListener('change', () => this.update(), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.update(), options);
        }
        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
            if (index >= 0 && this.mobile.matches) this.goTo(index, true);
          }, options);
        }
        this.update();
      }

      maximum() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      position(card) {
        return this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      }

      current() {
        const scroll = Math.max(0, Math.min(this.maximum(), this.track.scrollLeft));
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const difference = Math.abs(Math.min(this.maximum(), this.position(card)) - scroll);
          if (difference < distance) {
            distance = difference;
            nearest = index;
          }
        });
        return nearest;
      }

      goTo(index, immediate = false) {
        if (!this.mobile.matches) return;
        const safeIndex = Math.max(0, Math.min(this.cards.length - 1, index));
        this.track.scrollTo({
          left: Math.max(0, Math.min(this.maximum(), this.position(this.cards[safeIndex]))),
          behavior: immediate || this.motion.matches ? 'auto' : 'smooth'
        });
      }

      step(direction) {
        this.goTo(this.current() + direction);
      }

      update() {
        const active = this.mobile.matches && this.maximum() > 2;
        if (this.controls) this.controls.hidden = !active;
        if (!active) {
          this.track.removeAttribute('tabindex');
          this.track.removeAttribute('aria-label');
          this.removeAttribute('role');
          this.removeAttribute('aria-label');
          this.removeAttribute('aria-roledescription');
          return;
        }
        this.setAttribute('role', 'region');
        this.setAttribute('aria-label', 'Recettes et cours de pâtisserie');
        this.setAttribute('aria-roledescription', 'carrousel');
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('aria-label', 'Parcourir les offres');
        const current = this.current();
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= this.maximum() - 2;
        this.dots.forEach((dot, index) => {
          if (index === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
